<div class="video-popup h-p-100 " panelClass="video-dialog">
  <mat-dialog-content class="h-p-100 w-p-100 p-0 overflow-hidden">
    <video width="100%" height="100%" controls autoplay>
      <source src="assets/videos/help-video.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </mat-dialog-content>
</div>
<!-- <div class="video-popup">
  <iframe
    width="100%"
    height="450"
    src="https://www.youtube.com/embed/n_FCrCQ6-bA"
    title="Help Video"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen>
  </iframe>
</div> -->
